module.exports = __webpack_public_path__ + "static/pera-first-screen-8a11188ae4170abb87549c8fbf9ccbf6.png";